function Home() {
  return (
    <>
      <h1>Home</h1>
      <p>
        Welkom bij het Colland Dashboard
      </p>
    </>
  );
}

export default Home;
